/**
 * Global UI → Agent sync tracker (renders nothing).
 *
 * Mounted once in App:
 *  - reports every route change as a semantic `view_changed` ui_event
 *    (mapped onto the contract's closed view enum), and
 *  - mirrors the cart badge count into the screen-context snapshot.
 *
 * All heavy lifting (dedupe, echo tagging, socket state) lives in
 * services/uiAgentSync.js — this component is just the React binding.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useCart } from "../context/CartContext";
import {
  mapPathToView,
  trackViewChanged,
  setCartBadgeCount,
} from "../services/uiAgentSync";

export default function UiAgentSyncTracker() {
  const location = useLocation();
  const { totalItems } = useCart();

  useEffect(() => {
    setCartBadgeCount(totalItems);
  }, [totalItems]);

  useEffect(() => {
    const { view, viewParams } = mapPathToView(location.pathname);
    trackViewChanged(view, viewParams);
  }, [location.pathname]);

  return null;
}
